// THE WORKSPACE APPS VIEW (/apps) — docs/APP_SPLIT.md §5.2,
// WS-STUDIO-SPLIT-WORKSPACE-APPS-FROM-SITES. Nika 2026-10-19: "workspace apps
// are pure adons on workspace and websites made on it are deployed and
// published". The Apps hub has two views (CanvasViewNav VIEW_NAV): this one
// holds the add-ons of the workspace — installed, built by the team, offered
// by the App Store. Websites live on the /studio board, never here.
//
// Rows come from `appsHubModel` (functions/appsHub.js): each row carries every
// key it reads and an `app-…` key, so no row falls back to the root state and
// no data key names an HTML tag.

// One section: a heading and a grid of AppsHubCard rows. `sectionKey` names
// the model list it shows; the section hides when that list is empty.
export const AppsHubSection = {
  tag: 'section',
  flow: 'y',
  gap: 'Z2',
  minWidth: '0',
  sectionKey: 'installed',
  hideDeps: [
    'workspaceApps',
    'workspaceProject',
    'workspace',
    '_userApps',
    '_wsAppsCatalog',
    '_projectsForActiveOrg',
    '_workspacePresets'
  ],
  hide: (el, s) => !(el.call('appsHubModel', s.root)[el.sectionKey] || []).length,

  AhHeading: {
    tag: 'h2',
    margin: '0',
    fontSize: 'Z2',
    fontWeight: '700',
    color: 'caption',
    text: (el) =>
      el.call(
        'polyglot',
        el.parent.sectionKey === 'team'
          ? 'workspace.appsHub.section.team'
          : el.parent.sectionKey === 'store'
            ? 'workspace.appsHub.section.store'
            : 'workspace.appsHub.section.installed'
      )
  },

  AhGrid: {
    display: 'grid',
    gap: 'Z2',
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, var(--spacing-G)), 1fr))',
    childExtends: 'AppsHubCard',
    childrenAs: 'state',
    childrenDeps: [
      'workspaceApps',
      'workspaceProject',
      'workspace',
      '_userApps',
      '_wsAppsCatalog',
      '_projectsForActiveOrg',
      '_workspacePresets'
    ],
    children: (el, s) => el.call('appsHubModel', s.root)[el.parent.sectionKey] || []
  }
}
